import * as _ from 'lodash-es';
import PropTypes from 'prop-types';
import Star from 'components/Shared/StarRating/Star';

const MAX_NUMBER_STARS = 5;
export default function StarRating({ value = 0, className, isGold = false }) {
  const fullStars = _.times(value, (i) => {
    return <Star type="full" className={className} key={i} isGold={isGold} />;
  });

  const halfStar = Number(value) !== Math.ceil(value) && (
    <Star type="half" className={className} isGold={isGold} />
  );

  const emptyStarCount = MAX_NUMBER_STARS - Math.ceil(value);

  const emptyStars = _.times(emptyStarCount, (i) => {
    const step = Math.round(value) + i;

    return (
      <Star type="empty" className={className} key={step} isGold={isGold} />
    );
  });

  return (
    <div className="stars">
      {fullStars}
      {halfStar}
      {emptyStars}
      <style jsx>
        {`
          .stars {
            display: flex;
            align-items: center;
          }
        `}
      </style>
    </div>
  );
}

StarRating.propTypes = {
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
  isGold: PropTypes.bool,
};
